'use strict';
/**
 * @author Maxim Seredkin
 */

export default function okvedTree() {
    return {
        restrict: 'A',
        template: require('../view/src-category-tree.html'),
        scope: {
            selectedItem: '=myModel'
        },
        controller: ['$scope', '$routeParams', '$window', 'SrcCategoryRestService',
            function ($scope, $routeParams, $window, SrcCategoryRestService) {

                $scope.select = select;
                $scope.isSelect = isSelect;
                $scope.search = search;

                init();

                // region Function

                function init() {
                    $scope.loading = true;
                    $scope.isOpen = false;

                    $scope.filter = {};

                    $scope.columns = [{
                        data: 'code'
                    }, {
                        data: 'name'
                    }];

                    SrcCategoryRestService.root(null, (data) => {
                        $scope.items = data._embedded;
                        if ($scope.selectedItem != null) {
                            SrcCategoryRestService.path({srcCategoryId: $scope.selectedItem.id}, (data) => _update($scope.selectedItem, $scope.items, data._embedded));
                        }
                        $scope.loading = false;
                    });
                }

                function select(item) {
                    $scope.selectedItem = item;
                    if (!item.nodes) {
                        SrcCategoryRestService.childs({srcCategoryId: item.id}, (data) => item.nodes = data._embedded);
                    }
                }

                function isSelect(item) {
                    return $scope.selectedItem === item;
                }

                function _update(selectedItem, items, path) {
                    let item = items.find(i => i.id == path[0].id);
                    if (!item.nodes) {
                        SrcCategoryRestService.childs({srcCategoryId: item.id}, (data) => {
                            item.nodes = data._embedded;
                            path.splice(0, 1);
                            if (path.length > 0) {
                                _update(selectedItem, item.nodes, path);
                            } else {
                                $scope.select(item);
                                $scope.$applyAsync(function () {
                                    $scope.$broadcast("updateStateNode", null);
                                });
                            }
                        });
                    } else {
                        path.splice(0, 1);
                        if (path.length > 0) {
                            _update(selectedItem, item.nodes, path);
                        } else {
                            $scope.select(item);
                            $scope.$applyAsync(function () {
                                $scope.$broadcast("updateStateNode", null);
                            });
                        }
                    }
                }

                function search() {
                    if ($scope.filter.codeOkved != null && $scope.filter.codeOkved.length != 0) {
                        SrcCategoryRestService.get({filters: ["'code' EQ '" + $scope.filter.codeOkved + "'"]}, (data) => {
                            if (data._embedded != null && Array.isArray(data._embedded) && data._embedded.length > 0) {
                                $scope.selectedItem = data._embedded[0];
                            } else {
                                $scope.selectedItem = null;
                            }
                        });
                    } else {
                        $scope.selectedItem = null;
                    }
                }

                // endregion

                // region Watcher

                $scope.$watch('selectedItem', function () {
                    if ($scope.selectedItem != null) {
                        $scope.filter.codeOkved = $scope.selectedItem.code;
                        SrcCategoryRestService.path({srcCategoryId: $scope.selectedItem.id}, (data) => _update($scope.selectedItem, $scope.items, data._embedded));
                    }
                });

                // endregion

            }]
    };
}
